import api from './api';

export const getMyQuests      = () => api.get('/api/quests/me');
export const getWarriorOptions= () => api.get('/api/users/warrior-options');
export const updateWarrior    = (data) => api.put('/api/users/me/warrior', data);
